import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const FlightingIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
      <path
        d="M17 1.48764L6 11.4876V16.4876L9 13.4876M1 7.98764L17 1.45264L14.2 15.9876L1 7.98764Z"
        stroke={theme.palette.brandedTypography.textColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default FlightingIcon;
